import {Component, OnInit} from '@angular/core';
import {SharedService} from '../../../../services/shared.service';
import {Router} from '@angular/router';
import {formatDate} from '@angular/common';
import * as _ from 'lodash';
import {OrderService} from '../../../../services/order.service';
import {OrderModel} from '../../../../models/order.model';
import {MatSnackBar} from '@angular/material';
import {SNACK_CONFIG} from '../../../../global';

@Component({
  selector: 'app-result',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss']
})
export class ResultsComponent implements OnInit {
  todayPrices = [];
  tomorrowPrices = [];
  pricesLoaded = [];
  showToday: boolean;
  reschedule: OrderModel;

  constructor(private shared: SharedService,
              private router: Router,
              private orderService: OrderService,
              private snackBar: MatSnackBar) {
    this.shared.sendEvent({type: 'request_step', data: {step: 4, name: 'REQUEST.RESULTS.NAME'}});
    if (this.shared.getStep() != 'results') this.router.navigate(['account', 'request', 'fuel']);
  }

  ngOnInit() {
    let todayDate = formatDate(new Date(), 'MM/dd/yyyy', 'en-US');
    let tomorrowDate = formatDate(new Date(new Date().getTime() + 1000 * 60 * 60 * 24), 'MM/dd/yyyy', 'en-US');
    let order = this.shared.getOrder();
    let rescheduleOrder = this.shared.getRescheduleOrder();
    if (rescheduleOrder) this.checkExpiration(rescheduleOrder);

    let hours = [];
    let excludedDistributors = this.shared.getExcludedDistributors(); //Excluded distributors from results
    Object.getOwnPropertyNames(order['selectedHours']).map(key => {
      if (order['selectedHours'][key]) return hours.push(key.toLowerCase()); //Selected hours as array
    });
    //Request Data
    let rData = {
      'county': order['specs']['location']['county'],
      'state': order['specs']['location']['state'],
      'fuel': order['specs']['product']['fuelTypeID'],
      'amount': order['specs']['product']['amount'],
      'date': todayDate,
      'deliveryHours': hours
    };
    this.showToday = order.deliveryDate == todayDate || rescheduleOrder != null; //Show today prices if selected date is today or is reschedule order
    if (this.showToday) {
      //Get today prices
      this.orderService.getPrices(rData)
        .then(res => {
          let prices = [];
          res.forEach(price => {
            let nowHour = new Date().getHours(); //Get hour now
            let delivery = price.deliveryHours; //Get deliver hours
            if (delivery.indexOf('morning') != -1 && nowHour > 10) delivery.splice(delivery.indexOf('morning'), 1); //Remove morning if passed 9AM
            if (delivery.indexOf('afternoon') != -1 && nowHour > 15) delivery.splice(delivery.indexOf('afternoon'), 1); //Remove afternoon if passed 12PM
            if (delivery.indexOf('evening') != -1 && nowHour > 20) delivery.splice(delivery.indexOf('evening'), 1); //Remove evening if passed 17PM
            if (!excludedDistributors[price.uid] && delivery.length) prices.push(price);
          });
          this.todayPrices = _.sortBy(prices, ['price.perGallon']);
          this.pricesLoaded.push('today');
        })
        .catch(err => {
          this.pricesLoaded.push('today');
          console.log(err);
        });
    } else {
      this.pricesLoaded.push('today');
    }

    rData['date'] = tomorrowDate;
    if (this.showToday) rData['deliveryHours'] = ['morning', 'afternoon', 'evening'];
    //Get tomorrow price
    this.orderService.getPrices(rData)
      .then(res => {
        let prices = [];
        res.forEach(price => {
          if (!excludedDistributors[price.uid]) prices.push(price);
        });
        this.tomorrowPrices = _.sortBy(prices, ['price.perGallon']);
        this.pricesLoaded.push('tomorrow');
      })
      .catch(err => {
        this.pricesLoaded.push('tomorrow');
        console.log(err);
      });
  }

  backClicked() {
    this.router.navigate(['account', 'request', 'fuel']);
  }

  submitPrice(price) {
    let order = {
      distributor: price.uid,
      disTotal: price['price']['disTotal'],
      deliveryDate: price.date,
      date: formatDate(new Date(), 'HH:mm MM/dd/yyyy', 'en-US'),
      specs: {
        product: {
          minimumOrder: price['product']['minimumOrder'].toString(),
          price: price['product']['price'].toString(),
          productID: price['product']['id'],
          underMinFee: price['product']['underMinFee'].toString()
        }
      },
      selectedHours: {
        morning: price.deliveryHours.indexOf('morning') != -1,
        afternoon: price.deliveryHours.indexOf('afternoon') != -1,
        evening: price.deliveryHours.indexOf('evening') != -1,
        overnight: false
      },
      status: 0,
      total: price['price']['total'].toString()
    };
    this.shared.updateOrder(order, 'payment');
    return this.router.navigate(['account', 'request', 'payment']);
  }

  checkExpiration(order: OrderModel) {
    if (order.rescheduleExpire < new Date().getTime()) {
      order.status = 6;
      this.reschedule = null;
    } else {
      if (!this.reschedule) this.reschedule = order;
    }
  }

  cancelReschedule() {
    this.orderService.updateOrder(this.reschedule.id, {status: 6})
      .then(() => {
        this.snackBar.open('Order reschedule rejected', null, SNACK_CONFIG);
        return this.router.navigate(['account', 'request', 'fuel']);
      })
      .catch(() => {
        this.shared.openErrorDialog({title: 'Error', body: 'Unexpected error'});
      });
  }

  acceptReschedule() {
    this.orderService.updateOrder(this.reschedule.id, {status: 1})
      .then(() => {
        this.snackBar.open('Order reschedule accepted', null, SNACK_CONFIG);
        return this.router.navigate(['account', 'orders', 'details', this.reschedule.id]);
      })
      .catch(() => {
        this.shared.openErrorDialog({title: 'Error', body: 'Unexpected error'});
      });
  }

}
